import * as React from 'react';
import * as styles from './CommonService.css';
import { UnavailableReasonContainer } from './components';
import { getImage } from './utils';
import { ICommonServiceProps } from './types';
import { ServicePositionContainer } from '../ServicePosition';
import { DiscountLabel } from '../DiscountLabel';
import { ServiceWrapper } from '../ServiceWrapper';

export const CommonService = (props: ICommonServiceProps) => {
  const { id, name, description, isAvailable, isActive, discount, onCardClick } = props;

  const unavailableReason = <UnavailableReasonContainer serviceId={id} />;

  return (
    <ServiceWrapper isActive={isActive} isDisabled={!isAvailable} onClick={onCardClick}>
      <div dangerouslySetInnerHTML={getImage(id)} className={styles['image']} />

      <ServicePositionContainer serviceId={id} />

      <DiscountLabel discount={discount} />

      <div className={styles['body']}>
        <div className={styles['name']}>{name}</div>
        <div className={styles['description']}>{description}</div>
      </div>

      {!isAvailable && (
        <div className={styles['disabled_wrapper']}>
          {!!unavailableReason && <div className={styles['disabled_message']}>{unavailableReason}</div>}
        </div>
      )}
    </ServiceWrapper>
  );
};
